import * as React from 'react';
import SearchSuggestionResultContainer from './SearchSuggestionResultContainer';
import { LargeScreenLayout } from '../components/screen/LargeScreenLayout';
import { SmallScreenLayout } from '../components/screen/SmallScreenLayout';
import useFetchSearchSuggestion from 'PyzShopUi/scripts/search-suggestion/hooks/useFetchSearchSuggestion';
import useHandleScrollEffect from 'PyzShopUi/scripts/search-suggestion/hooks/useHandleScrollEffect';

interface ISearchSuggestionContainerProps {
    searchValue: string;
    isVisible: boolean;
    isSmallScreen: boolean;
    minSearchStringLengthToGetData: number;
    searchUrl: string;

    onClose(): void;
}

const SearchSuggestionContainer: React.FunctionComponent<ISearchSuggestionContainerProps> = props => {
    const {
        searchValue,
        isVisible,
        isSmallScreen,
        minSearchStringLengthToGetData,
        searchUrl,
        onClose
    } = props;

    const suggestions = useFetchSearchSuggestion(searchValue, minSearchStringLengthToGetData);

    useHandleScrollEffect(isVisible, isSmallScreen, suggestions);

    if (isSmallScreen) {
        return (
            <SmallScreenLayout
                searchValue={searchValue}
                isVisible={isVisible}
                searchUrl={searchUrl}
                onClose={onClose}
            >
                <SearchSuggestionResultContainer data={suggestions} searchValue={searchValue}/>
            </SmallScreenLayout>
        );
    }

    if (!suggestions || !suggestions.length) {
        return null;
    }

    return (
        <LargeScreenLayout isVisible={isVisible} onClose={onClose}>
            <SearchSuggestionResultContainer data={suggestions} searchValue={searchValue}/>
        </LargeScreenLayout>
    );
};

SearchSuggestionContainer.defaultProps = {
    searchValue: ''
};

export default SearchSuggestionContainer;
